import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, CircularProgress } from '@mui/material';
import apiClient from "../BaseUrl/apiClient";
import { IP, Copyright, Developer } from '../constants/Constants';
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Login } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import TokenService from "../service/TokenService";
import { useAuthentication } from "../customHook/useAuthentecation";

const LoginPage = () => {
  const [userId, setUserId] = useState('');
  const [pageLoader, setPageLoader] = useState(false);
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1); // 1: Credentials, 2: OTP
  const [showPassword, setShowPassword] = useState(false);
  const { setAuth } = useAuthentication();
  const [logindata, setLogindata] = useState(
    {
      username: "amit",
      right: 1,
    }
  );
  const navigate = useNavigate();

  // Handle login submit
  const handleLoginSubmit = async () => {
    setPageLoader(true);
    try {
      const response = await apiClient.post('/login', { userId, password });
      alert(response.data.message);
      setStep(2); // Move to OTP step
    } catch (error) {
      alert(error.response?.data?.message || 'Login failed');
    }
    setPageLoader(false);
  };

  // Handle OTP submit
  const handleOtpSubmit = async () => {
    setPageLoader(true);
    try {
      const response = await apiClient.post('/verify-otp', { userId, otp });
      alert(response.data.message);
      TokenService.setTokenDetails(logindata);
      setAuth(logindata);
      navigate("/dashboard");
    } catch (error) {
      alert(error.response?.data?.message || 'OTP verification failed');
    }
    setPageLoader(false);
  };

  // Toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  // Handle keypress for moving to next step
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (step === 1) {
        handleLoginSubmit();
      } else if (step === 2) {
        handleOtpSubmit();
      }
    }
  };

  return (


<>
{pageLoader && (
        <div className="loaderContainer">
          <CircularProgress />
        </div>
      )}


    <div className="container">
      
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          padding: 2,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: '100%', // Fixed width for better PC layout
            padding: 4,
            borderRadius: 2,
            textAlign: 'center',
          }}
        >
          <Typography variant="h5" sx={{ mb: 3 }}>
            {step === 1 ? 'Login' : 'Verify OTP'}
          </Typography>

          {step === 1 && (
            <>
              <TextField
                label="User ID"
                variant="outlined"
                fullWidth
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                onKeyPress={handleKeyPress} // Add onKeyPress event
                sx={{ mb: 2 }}
              />
              <TextField
                label="Password"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress} // Add onKeyPress event
                sx={{ mb: 3 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                fullWidth
                onClick={handleLoginSubmit}
                startIcon={<Login />}
                sx={{
                  py: 1.2,
                  fontSize: '16px',
                  backgroundColor: '#1976d2',
                  '&:hover': { backgroundColor: '#155a9b' },
                }}
              >
                Login
              </Button>
            </>
          )}

          {step === 2 && (
            <>
              <TextField
                label="Enter OTP"
                variant="outlined"
                fullWidth
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                onKeyPress={handleKeyPress} // Add onKeyPress event
                sx={{ mb: 3 }}
              />
              <Button
                variant="contained"
                fullWidth
                onClick={handleOtpSubmit}
                sx={{
                  py: 1.2,
                  fontSize: '16px',
                  backgroundColor: '#1976d2',
                  '&:hover': { backgroundColor: '#155a9b' },
                }}
              >
                Verify OTP
              </Button>
            </>
          )}

          <Typography variant="body2" sx={{ mt: 4, color: 'gray' }}>
            Your IP : {IP}
          </Typography>

          {Developer()}
          {Copyright()}
        </Paper>
      </Box>
    </div>
    </>
  );
  
};

export default LoginPage;
